'use client';
import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { tomorrowNightBright } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export const DebugJsonBlock: React.FC<{
  block: any;
  label?: string;
}> = ({ block, label }) => {
  return null;
  // return (
  //   <div className="debug-data col-12">
  //     <details>
  //       <summary>
  //         View JSON
  //         {label && `: ${label}`}
  //       </summary>
  //       <pre style={tomorrowNightBright}>
  //         {JSON.stringify(block, null, 2)}
  //       </pre>
  //     </details>
  //   </div>
  // );
};
